import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { sKey } from '@easy-lib/modules/shared/services/session-storage.service';

@Injectable({
	providedIn: 'root'
})
export class UserService {
	public userCheckedSubject = new BehaviorSubject<boolean>(false);
	public userChecked$ = this.userCheckedSubject.asObservable();

	isEasy2User = false;
	get isGuestUser(): boolean {
		return sessionStorage.getItem(sKey.isGuestUser) === 'true';
	}

	set isGuestUser(value: boolean) {
		sessionStorage.setItem(sKey.isGuestUser, String(value));
	}
	userChecked() {
		if (!this.userCheckedSubject.getValue()) {
			this.userCheckedSubject.next(true);
		}
	}

	getValue() {
		return this.userCheckedSubject.getValue();
	}
}
